/**
 * useFilterState - Hook per gestire lo stato dei filtri
 * Calcola automaticamente se ci sono filtri attivi e il loro conteggio
 */

import { useMemo } from 'react';

interface FilterState {
  [key: string]: any;
}

interface UseFilterStateReturn {
  hasActiveFilters: boolean;
  activeFiltersCount: number;
  activeFilters: string[];
}

export const useFilterState = (filters: FilterState): UseFilterStateReturn => {
  const { hasActiveFilters, activeFiltersCount, activeFilters } = useMemo(() => {
    const activeFiltersList: string[] = [];
    let count = 0;

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        // Per array, controlla se non è vuoto
        if (Array.isArray(value) && value.length > 0) {
          activeFiltersList.push(key);
          count++;
        }
        // Per stringhe, controlla se non è vuota (escludendo spazi)
        else if (typeof value === 'string' && value.trim() !== '') {
          activeFiltersList.push(key);
          count++;
        }
        // Per numeri, controlla se è maggiore di 0
        else if (typeof value === 'number' && value > 0) {
          activeFiltersList.push(key);
          count++;
        }
        // Per booleani, controlla se è true
        else if (typeof value === 'boolean' && value === true) {
          activeFiltersList.push(key);
          count++;
        }
      }
    });

    return {
      hasActiveFilters: count > 0,
      activeFiltersCount: count,
      activeFilters: activeFiltersList
    };
  }, [filters]);

  return {
    hasActiveFilters,
    activeFiltersCount,
    activeFilters
  };
};
